import { render } from "./App.vue?vue&type=template&id=887ad0ec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=887ad0ec&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__